import { useApplicationModals } from "app/common/hooks";
import { ModalMolecule } from "app/components/molecules/modal";
import { usePaginatedCollector } from "app/integration/common/hooks";
import { useState, useEffect } from "react";
import Table from "app/components/atoms/table";
import Typography from "app/components/atoms/typography";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import { Badge } from "app/components/atoms/badge";
import { BadgeButton, IconButton, ServerSidePaginationButtons } from "app/components/atoms/button";
import { Input, SearchInput } from "app/components/atoms/input";
import { FormHeader } from "app/components/atoms/layout";

function ChooseSalesOrderModal({ onSuccess = () => { } }) {
  const { showStates, getPayloads, closeModal } = useApplicationModals();
  const payload = getPayloads("salesOrder.choose");

  const handleClose = () => {
    closeModal("salesOrder.choose");
  };
  const handleSuccess = (data) => {
    closeModal("salesOrder.choose");
    onSuccess(data);
  };

  const [params, setParams] = useState({
    status: 4,
    page: 1,
    limit: 50,
  });

  const [searchValue, setSearchValue] = useState('');

  const [
    deliveryOrders,
    setDeliveryOrders,
    deliveryOrdersLoader,
    collectDeliveryOrders,
    deliveryOrderPaginationProps,
  ] = usePaginatedCollector({ modelName: "deliveryOrder", params: params });

  const filteredDeliveryOrders = searchValue
    ? deliveryOrders?.filter((deliveryOrder) => {
        const orderCode = deliveryOrder.order_code?.toLowerCase() || '';
        const customerName = `${deliveryOrder.MCustomer?.firstName || ''} ${deliveryOrder.MCustomer?.middleName || ''} ${deliveryOrder.MCustomer?.lastName || ''}`.toLowerCase();
        const salesChannel = deliveryOrder?.sales_channel?.name?.toLowerCase() || '';

        return (
          orderCode.includes(searchValue.toLowerCase()) ||
          customerName.includes(searchValue.toLowerCase()) ||
          salesChannel.includes(searchValue.toLowerCase())
        );
      })
    : deliveryOrders;

  return (
    <ModalMolecule
      show={showStates["salesOrder.choose"]}
      title="Sales Order"
      onClose={handleClose}
      size="sm"
    >
      <Table.Container>
        <Table.UtilitiesWrapper>
          <Table.SearchBarWrapper>
            <FormHeader appearance="none">
              <SearchInput testId="modal-choose-sales-order-search-input"
                placeholder="Cari Order"
                type="text"
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </FormHeader>
          </Table.SearchBarWrapper>
        </Table.UtilitiesWrapper>
        <Table.Wrapper asIndex={true}>
          <Table.Header>
            <Table.HeaderRow>
              <Table.Heading>No.</Table.Heading>
              <Table.Heading>Customer</Table.Heading>
              <Table.Heading>Status</Table.Heading>
              <Table.Heading></Table.Heading>
            </Table.HeaderRow>
          </Table.Header>
          <Table.Body>
            {filteredDeliveryOrders?.map((deliveryOrder, key) => (
              <Table.BodyRow key={key}>
                <Table.Cell>
                  <p>{deliveryOrder?.SalesOrder?.order_code}</p>
                  <Typography.Date
                    format="dd MMM yyyy"
                    size="xs"
                    date={deliveryOrder.createdAt}
                  />
                </Table.Cell>
                <Table.Cell>
                  <p>
                    {deliveryOrder.MCustomer?.firstName} {deliveryOrder.MCustomer?.middleName} {deliveryOrder.MCustomer?.lastName}
                    {deliveryOrder.delivery_to !== deliveryOrder.customer_id && deliveryOrder.MCustomer?.nickName !== null && deliveryOrder.MCustomer?.nickName !== "" && " (" + deliveryOrder.MCustomer?.nickName + ")"}
                  </p>
                  <p className="text-gray-500 font-light text-sm">
                    {deliveryOrder.MCustomer?.phone !== null && deliveryOrder.MCustomer?.phone !== "" && deliveryOrder.MCustomer?.phone}
                  </p>
                </Table.Cell>
                <Table.Cell className="hidden lg:table-cell">
                  <p className="text-left">{deliveryOrder?.sales_info?.email}</p>
                </Table.Cell>
                <Table.Cell>
                  <Badge color={deliveryOrder.status == 4 ? "green" : "yellow"}>
                    {deliveryOrder.status == 4 ? "Sudah dikirim" : "Quotation"}
                  </Badge>
                </Table.Cell>
                <Table.Cell>
                  <div className="flex space-x-2">
                    <div className="flex">
                      <BadgeButton testId="modal-choose-sales-order-pilih-button"
                        color="green"
                        onClick={() => {
                          handleSuccess(deliveryOrder);
                        }}
                      >
                        Pilih
                      </BadgeButton>
                    </div>
                  </div>
                </Table.Cell>
              </Table.BodyRow>
            ))}
          </Table.Body>
        </Table.Wrapper>
        <Table.PaginationWrapper>
          <ServerSidePaginationButtons
            paginationProps={deliveryOrderPaginationProps}
            params={params}
            setParams={setParams}
          />
        </Table.PaginationWrapper>
      </Table.Container>
    </ModalMolecule>
  );
}

export default ChooseSalesOrderModal;
